import http from 'api/httpClient';
import { BranchDataRequest, BranchDataResponse, CustomerDataRequest, CustomerDataResponse } from "@/pages/customer-data/api";

// Key Accounts – Customers
export async function fetchKeyAccountsData(
  params: CustomerDataRequest
): Promise<CustomerDataResponse> {
  return http.post('/api/v1/reports/customers/key_accounts', params);
}

// Key Accounts – Branches
export async function fetchKeyAccountBranchData(
  params: BranchDataRequest
): Promise<BranchDataResponse> {
  return http.post('/api/v1/reports/customers/key_accounts/branches', params);
}

export const updateKeyAccountsDropdowns = (payload: {
  year: string;
  selection: Record<string, string[]>;
}) => {
  return http.post('/api/v1/reports/key_accounts/update-dropdowns', payload)
};